import { render } from "./AppDownloadCTA.vue?vue&type=template&id=745732de&scoped=true"
import script from "./AppDownloadCTA.vue?vue&type=script&lang=js"
export * from "./AppDownloadCTA.vue?vue&type=script&lang=js"

import "./AppDownloadCTA.vue?vue&type=style&index=0&id=745732de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745732de"]])

export default __exports__